"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_NUMBER_VALIDATOR = void 0;
exports.PHONE_NUMBER_VALIDATOR = /^[0-9]{8,11}$/;
//# sourceMappingURL=regex.js.map